import { render, staticRenderFns } from "./smart-news.vue?vue&type=template&id=239e52b4&scoped=true&"
import script from "./smart-news.vue?vue&type=script&lang=js&"
export * from "./smart-news.vue?vue&type=script&lang=js&"
import style0 from "./smart-news.vue?vue&type=style&index=0&id=239e52b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239e52b4",
  null
  
)

export default component.exports